import { useNavigate } from "react-router-dom";

import CitiesService from "../../../services/http/services/CitiesService";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import { EmitError } from "../../../utils/EmitError";
import useAuth from "../../../hooks/useAuth";
import { IPanelUser } from "../../../interfaces";

export default function useNewCity() {
    const navigate = useNavigate();
    const { user, updateUserData, setUserActiveCity, updateUserCityOnStorage,  } = useAuth();

    async function handleSubmit(city: FormData) {
        try {
            const newCity = await CitiesService.createCity(city);
            EmitSuccessAlert('Município cadastrado com sucesso!');


            await updateCityOnUser(newCity);
            navigate('/municipios');
        } catch (err) {
            EmitError(err, true, 'newCity_auisdhiasdhuad');
        }
    }

    async function updateCityOnUser(newCity: any) {
        try {

            if(!user) {
                return;
            }

            const updateUser: IPanelUser = {
                ...user,
                cities: [...user.cities, newCity]

            }

            await updateUserData(updateUser);
            await setUserActiveCity(newCity);
            updateUserCityOnStorage(newCity);

        } catch (err) {
            EmitError(err, true, 'newCity_auisdhiasdhuad');
        }
    }



    return {
        handleSubmit
    }

}
